import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import './AdminLayout.css';

function AdminLayout({ children }) {
  const { currentUser, isAdmin } = useAuth();
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setSidebarVisible(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Redirect if user is not authenticated or not an admin
  if (!currentUser || !isAdmin) {
    return <Navigate to="/login" />;
  }

  return (
    <div className={`admin-layout ${sidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
      <AdminSidebar isVisible={sidebarVisible} />
      <div className="sidebar-toggle-container">
        <button 
          className="sidebar-toggle-btn" 
          onClick={toggleSidebar}
          aria-label={sidebarVisible ? "Hide Sidebar" : "Show Sidebar"}
        >
          {sidebarVisible ? '◀' : '▶'}
        </button>
      </div>
      <div className="admin-content-wrapper">
        {children}
      </div>
    </div>
  );
}

export default AdminLayout; 